import { textStyleCss } from 'src/theme/atlas';
import styled from 'styled-components';

export const CardBodySubtitle = styled.div`
  margin-bottom: 16px;
  color: ${(props) => props.theme.atlas.semantic.color.type.default};
  ${({ theme }) => textStyleCss(theme.atlas.typography.semantic.bodySmall)};
`;

export const CardHeaderStyled = styled.div`
  color: ${(props) => props.theme.newPalette.neutral.N800};
  ${(props) => props.theme.newTypography.textStyleHeading};
`;

export const CardBodyStyled = styled.div`
  ${({ theme }) => textStyleCss(theme.atlas.typography.semantic.bodySmall)}
  padding: 20px;
  display: flex;
  flex-direction: row;
  gap: 20px;
`;

export const CategoriesTagsWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
`;

export const CardSection = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  padding: 8px;
  gap: 24px;
`;

export const DynamicSectionTitle = styled.div`
  ${({ theme }) => textStyleCss(theme.atlas.typography.semantic.headingH3)}
  color: ${(props) => props.theme.atlas.semantic.color.type.default};
  margin: 0;
`;

export const InformationBannerContainer = styled.div`
  padding: 20px;
`;

export const EmptyStateWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
`;

export const EmptyStateTitle = styled.h4`
  ${({ theme }) => textStyleCss(theme.atlas.typography.semantic.body)}
  font-weight: 600;
  color: ${(props) => props.theme.atlas.semantic.color.type.default};
  margin: 0;
`;

export const EmptyStateDescription = styled.p`
  ${({ theme }) => textStyleCss(theme.atlas.typography.semantic.bodySmall)}
  color: ${(props) => props.theme.atlas.semantic.color.type.default};
  margin: 0;
  text-align: center;
`;

export const QuestionsList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const QuestionWrapper = styled.div`
  display: flex;
  gap: 8px;
`;

export const QuestionCell = styled.div<{
  $size?: string;
  $header?: boolean;
  $center?: boolean;
}>`
  display: flex;
  flex: ${(props) => (props.$size ? props.$size : 1)};
  padding: 8px;
  border-radius: 4px;
  color: ${(props) => props.theme.atlas.semantic.color.type.default};
  justify-content: ${(props) => (props.$center ? 'center' : 'flex-start')};
  background-color: ${(props) =>
    props.$header
      ? props.theme.atlas.core.color.gray[300]
      : props.theme.atlas.core.color.gray[100]};
  align-items: center;
`;
